import { youTubeId } from '@/utils/youtube'
import type { EmotionStimulus } from '@/services/emotionAnalysisService'

/** Whether this stimulus renders as a real, seekable <video> element. */
export function stimulusHasVideo(stimulus: EmotionStimulus | null): boolean {
  if (!stimulus || !stimulus.url) return false
  if (stimulus.type === 'video') return true
  return stimulus.type === 'url' && !youTubeId(stimulus.url)
}

/** Whether this stimulus has a player that owns the panel's clock while it
 *  plays: a real <video>, or a YouTube link played through the IFrame API
 *  (YouTubeStage). Everything else runs on the panel's wall-clock. */
export function stimulusDrivesClock(stimulus: EmotionStimulus | null): boolean {
  return stimulusHasVideo(stimulus) || (!!stimulus && stimulus.type === 'url' && !!youTubeId(stimulus.url))
}
